// import React, { useEffect, useState } from "react";
// import Section from "../components/Section.jsx";
// import EventCard from "../components/EventCard.jsx";
// import { apiTrending } from "../api/events.js";
// import { useSearchParams } from "react-router-dom";

// export default function TrendingPage() {
//   const [items, setItems] = useState([]);
//   const [params] = useSearchParams();
//   const city = params.get("city") || "Mumbai";

//   useEffect(()=>{ apiTrending(city).then(setItems); },[city]);

//   return (
//     <main className="mx-auto max-w-7xl px-4 py-8">
//       <Section title={`Trending in ${city}`}>
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//           {items.map((e)=> <EventCard key={e.id} item={e} compact showBookButton={false} />)}
//         </div>
//       </Section>
//     </main>
//   );
// }

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Section from "../components/Section.jsx";
import EventCard from "../components/EventCard.jsx";
import { apiTrendingAll } from "../api/events.js";

export default function TrendingPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [params] = useSearchParams();
  const city = params.get("city") || "Mumbai";

  useEffect(() => {
    apiTrendingAll(city)
      .then(setItems)
      .finally(() => setLoading(false));
  }, [city]);

  return (
    <Section title={`Trending in ${city}`}  fullBleed>
      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="h-72 rounded-2xl bg-white animate-pulse" />
          ))}
        </div>
      ) : items.length ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((e) => (
            <EventCard key={e.id} item={e} compact showBookButton={false} />
          ))}
        </div>
      ) : (
        <div className="p-6 rounded-xl bg-white">No trending events for {city}.</div>
      )}
    </Section>
  );
}

